import { writable } from "svelte/store";

/**
 * A store that keeps track of whether the scroll should be locked.
 */
export const scrollLockStore = writable(false);
